// @flow
/* eslint-disable no-shadow */
import React from 'react';
import Toggle from 'react-toggled';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import RadioGroup from '@material-ui/core/RadioGroup';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import { withTranslation } from 'react-i18next';
import ExpandLessOutlinedIcon from '@material-ui/icons/ExpandLessOutlined';
import ExpandMoreOutlinedIcon from '@material-ui/icons/ExpandMoreOutlined';
import ScribeComfortOption from '../../../assets/icons/scribe-comfort-option.svg';
import ScribeFast from '../../../assets/icons/scribe-fast.svg';
import ScribeAccurate from '../../../assets/icons/scribe-accurate.svg';
import { EmptyIcon, styles } from '../../modules/scribe/SidebarHelpers';
import { toggleSideBar, updateFullScreen } from '../../actions';
import { useDispatch } from 'react-redux';
import Radio from '@material-ui/core/Radio';
import {
  ScribeCorrectionModeAccurate,
  ScribeCorrectionModeDefault,
  ScribeCorrectionModeFast,
  ScribeCorrectionModeUnset,
} from '../../types/config';
import type { ScribeCorrectionMode } from '../../types/config';
import { setScribeCorrectionMode } from '../../actions/config';
import { hasScribe, pendingScribe } from '../../utils/status';

function CaptionsSettings({
  classes,
  scribeCorrectionMode,
  status,
  t,
  theme,
}: {
  classes: Object,
  status: Object,
  t: Object,
  theme: Object,
  scribeCorrectionMode: ScribeCorrectionMode,
}) {
  if (!hasScribe(status) && !pendingScribe(status)) return null;
  const dispatch = useDispatch();
  const shownCorrectionMode =
    scribeCorrectionMode !== ScribeCorrectionModeUnset ? scribeCorrectionMode : ScribeCorrectionModeDefault;
  const handleChange = newCorrectionMode => {
    dispatch(setScribeCorrectionMode(newCorrectionMode));
  };
  return (
    <Toggle key="0_toggle_array" defaultOff>
      {({ on, getTogglerProps }) => [
        <ListItem
          button
          {...getTogglerProps()}
          key="toggle_head"
          classes={{
            focused: classes.root,
          }}
        >
          <ListItemIcon>
            <img src={ScribeComfortOption} alt="scribe_comfort_option" />
          </ListItemIcon>
          <ListItemText
            classes={{ root: classes.listItemText }}
            primary={t('editorSettings.correctionMode.configName')}
          />
          <ListItemIcon classes={{ root: classes.expandIcon }}>
            {on ? <ExpandLessOutlinedIcon /> : <ExpandMoreOutlinedIcon />}
          </ListItemIcon>
        </ListItem>,
        <Collapse in={on} key="toggle_collapse">
          <List style={{ paddingLeft: 10 }}>
            <ListItem>
              <RadioGroup aria-label="scribe-comfort-option-radio" name="mode" value={shownCorrectionMode}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <div
                    style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                    onClick={() => handleChange(ScribeCorrectionModeFast)}
                  >
                    <Radio size="small" style={{ color: theme.palette.ava.blue }} value={ScribeCorrectionModeFast} />
                    <ListItemIcon style={{ minWidth: 24 }}>
                      <img src={ScribeFast} alt="Scribe Comfort Option Fast" />
                    </ListItemIcon>
                    <ListItemText>{t('editorSettings.correctionMode.fastMode')}</ListItemText>
                  </div>
                  <ListItemText
                    style={{ marginLeft: 10, marginTop: -10 }}
                    secondary={t('editorSettings.correctionMode.fastModeDesc')}
                  />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <div
                    style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                    onClick={() => handleChange(ScribeCorrectionModeAccurate)}
                  >
                    <Radio
                      size="small"
                      style={{ color: theme.palette.ava.blue }}
                      value={ScribeCorrectionModeAccurate}
                    />
                    <ListItemIcon style={{ minWidth: 24 }}>
                      <img src={ScribeAccurate} alt="Scribe Comfort Option Accurate" />
                    </ListItemIcon>
                    <ListItemText>{t('editorSettings.correctionMode.accurateMode')}</ListItemText>
                  </div>
                  <ListItemText
                    style={{ marginLeft: 10, marginTop: -10 }}
                    secondary={t('editorSettings.correctionMode.accurateModeDesc')}
                  />
                </div>
              </RadioGroup>
            </ListItem>
          </List>
        </Collapse>,
      ]}
    </Toggle>
  );
}

const mapStateToProps = ({
  scribeConversation: { status },
  scribeTranscriptUI: { correctionMode },
  scribeSession: { captioner },
}) => ({
  user: captioner,
  scribeCorrectionMode: correctionMode,
  status,
});

export default connect(mapStateToProps, {
  toggleSideBar,
  updateFullScreen,
})(withTranslation()(withStyles(styles, { withTheme: true })(withRouter(CaptionsSettings))));
